export enum ProductType {
  INSTALLATION_KIT = 'installation_kit',
  PLUG_AND_PLAY = 'plug_and_play',
  SMART_ELECTRICAL_CABINET = 'smart_electrical_cabinet',
  SPINE_MODULE = 'spine_module',
  VALVE = 'valve'
}
